/**
 * Resolve a public asset path for subdirectory hosting (/guidance).
 * Usage: asset('/images/logo_school_new.png')
 */
export function asset(path = '') {
  const base = (process.env.PUBLIC_URL || '').replace(/\/$/, '');
  const normalized = path.startsWith('/') ? path : `/${path}`;
  return `${base}${normalized}`;
}

export default asset;
